export const useRealLocalStorage = (key: string) => {
  const setItem = (item: any) => {
    const jsonItem = JSON.stringify(item);

    localStorage.setItem(key, jsonItem);
  };

  const item = () => {
    const localItem = localStorage.getItem(key);

    if (localItem) return JSON.parse(localItem);

    return null;
  };

  const remove = () => {
    localStorage.removeItem(key);
  };

  return [item(), setItem, remove];
};
